.downloadButton {
	align-items: center;
	background-color: #2a72da;
	border-radius: 0.75rem;
	border: 0.25rem solid #fff;
	color: #fff;
	display: flex;
	gap: 1rem;
	justify-content: space-between;
	padding: 0.75rem;
	padding-inline-start: 1.25rem;
	text-align: start;
	text-decoration: none;

	.downloadButtonTextContainer {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
		line-height: 1;

		.downloadButtonEyebrow {
			text-transform: none;
		}

		.downloadButtonLabel {
			font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
			font-size: 32px;
			text-transform: uppercase;
		}
	}

	.downloadButtonIcon {
		fill: #fff;
		height: 2rem;
		width: 2rem;
	}
}
